(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-scroll-collections"] && !Shopify.designMode) return;
  try {
    
  function initGalleryScrollRows(root) {
    root.querySelectorAll('[data-gallery-scroll-row]').forEach((row) => {
      const track = row.querySelector('[data-gallery-scroll-track]');
      const prev = row.querySelector('[data-gallery-scroll-prev]');
      const next = row.querySelector('[data-gallery-scroll-next]');

      if (!track || !prev || !next) return;

      if (!row.hasAttribute('data-gallery-scroll-ready')) {
        row.setAttribute('data-gallery-scroll-ready', 'true');

        const scrollTrack = (direction) => {
          const distance = Math.max(track.clientWidth * 0.78, 280);
          track.scrollBy({
            left: direction * distance,
            behavior: 'smooth',
          });
        };

        prev.addEventListener('click', () => scrollTrack(-1));
        next.addEventListener('click', () => scrollTrack(1));
        track.addEventListener('scroll', () => updateArrows(), { passive: true });

        if ('ResizeObserver' in window) {
          new ResizeObserver(() => updateArrows()).observe(track);
        }

        track.querySelectorAll('img').forEach((image) => {
          image.addEventListener('load', () => updateArrows(), { once: true });
        });
      }

      const updateArrows = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const itemCount = track.querySelectorAll('.sp-gallery-scroll__item').length;
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft >= maxScroll - 2;

        prev.hidden = itemCount < 2 || atStart;
        next.hidden = itemCount < 2 || (maxScroll > 2 && atEnd);
      };

      requestAnimationFrame(updateArrows);
      window.setTimeout(updateArrows, 250);
      window.setTimeout(updateArrows, 900);
    });
  }

  initGalleryScrollRows(document);

  document.addEventListener('shopify:section:load', (event) => {
    initGalleryScrollRows(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function initHomeHeroSlideshows(root = document) {
    root.querySelectorAll('[data-home-hero-slideshow]').forEach((slideshow) => {
      const slides = Array.from(slideshow.querySelectorAll('[data-home-hero-slide]'));

      if (slideshow.homeHeroSlideshowTimer) {
        window.clearInterval(slideshow.homeHeroSlideshowTimer);
        slideshow.homeHeroSlideshowTimer = null;
      }

      if (slides.length <= 1) {
        slides[0]?.classList.add('is-active');
        return;
      }

      slideshow.setAttribute('data-home-hero-ready', 'true');

      let index = slides.findIndex((slide) => slide.classList.contains('is-active'));

      if (index < 0) {
        index = 0;
        slides[index].classList.add('is-active');
      }

      const interval = Number(slideshow.dataset.interval) || 5000;

      slideshow.homeHeroSlideshowTimer = window.setInterval(() => {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, interval);
    });
  }

  initHomeHeroSlideshows(document);

  document.addEventListener('shopify:section:load', (event) => {
    initHomeHeroSlideshows(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["private-events"] && !Shopify.designMode) return;
  try {
    
  function initPrivateEventCarousels(root) {
    root.querySelectorAll('[data-sp-private-carousel]:not([data-sp-private-ready])').forEach((carousel) => {
      const track = carousel.querySelector('[data-sp-private-track]');
      const prev = carousel.querySelector('[data-sp-private-prev]');
      const next = carousel.querySelector('[data-sp-private-next]');

      if (!track || !prev || !next) return;

      carousel.setAttribute('data-sp-private-ready', 'true');

      const getScrollAmount = () => {
        const slide = track.querySelector('.sp-private-events__slide');
        return slide ? slide.getBoundingClientRect().width : track.clientWidth;
      };

      const updateArrows = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= maxScroll - 2 || maxScroll <= 2;
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateArrows).observe(track);
      }

      requestAnimationFrame(updateArrows);
    });
  }

  initPrivateEventCarousels(document);

  document.addEventListener('shopify:section:load', (event) => {
    initPrivateEventCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
